import template from './route_performance.html'
import controller from './route_performance.controller'
import './route_performance.scss'

const routePerformanceComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template,
    controller
}

export default routePerformanceComponent;


// WEBPACK FOOTER //
// ./client/app/components/reporting/components/route_performance/route_performance.component.js